// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"181":"67bbb048","320":"6e832473","662":"9859d9af","692":"c7565bc3","790":"adfff99c","815":"c7565bc3","843":"cac3387d","887":"6e832473"}[chunkId] + ".chunk.css";
};